import { Injectable, Component, NgModule, defineInjectable } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatAutocompleteModule, MatButtonModule, MatFormFieldModule, MatInputModule, MatTableModule, MatCardModule, MatSnackBarModule, MatListModule, MatIconModule, MatButtonToggleModule, MatSelectModule, MatDialogModule, MatSortModule, MatCheckboxModule, MatChipsModule, MatProgressSpinnerModule, MatTooltipModule, MatDividerModule, MatRadioModule, MatProgressBarModule, MatMenuModule, MatSlideToggleModule } from '@angular/material';
import { CdkTableModule } from '@angular/cdk/table';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vendor-lib.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VendorLibService = /** @class */ (function () {
    function VendorLibService() {
    }
    VendorLibService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    VendorLibService.ctorParameters = function () { return []; };
    /** @nocollapse */ VendorLibService.ngInjectableDef = defineInjectable({ factory: function VendorLibService_Factory() { return new VendorLibService(); }, token: VendorLibService, providedIn: "root" });
    return VendorLibService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vendor-lib.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VendorLibComponent = /** @class */ (function () {
    function VendorLibComponent() {
    }
    /**
     * @return {?}
     */
    VendorLibComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    VendorLibComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ilp-vendor-vendor-lib',
                    template: "\n    <p>\n      vendor-lib works!\n    </p>\n  "
                }] }
    ];
    /** @nocollapse */
    VendorLibComponent.ctorParameters = function () { return []; };
    return VendorLibComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vendor-lib.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VendorLibModule = /** @class */ (function () {
    function VendorLibModule() {
    }
    VendorLibModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [VendorLibComponent],
                    imports: [
                        MatFormFieldModule,
                        MatTableModule,
                        MatInputModule,
                        MatButtonModule,
                        MatAutocompleteModule,
                        MatCardModule,
                        MatSnackBarModule,
                        MatListModule,
                        MatIconModule,
                        MatButtonToggleModule,
                        MatSelectModule,
                        MatDialogModule,
                        MatSortModule,
                        MatCheckboxModule,
                        MatChipsModule,
                        MatProgressSpinnerModule,
                        MatProgressBarModule,
                        MatTooltipModule,
                        MatDividerModule,
                        MatRadioModule,
                        CdkTableModule,
                        MatMenuModule,
                        MatSlideToggleModule,
                        FlexLayoutModule
                    ],
                    exports: [
                        MatFormFieldModule,
                        MatTableModule,
                        MatInputModule,
                        MatButtonModule,
                        MatAutocompleteModule,
                        MatCardModule,
                        MatSnackBarModule,
                        MatListModule,
                        MatIconModule,
                        MatButtonToggleModule,
                        MatSelectModule,
                        MatDialogModule,
                        MatSortModule,
                        MatCheckboxModule,
                        MatChipsModule,
                        MatProgressSpinnerModule,
                        MatProgressBarModule,
                        MatTooltipModule,
                        MatDividerModule,
                        MatRadioModule,
                        CdkTableModule,
                        MatMenuModule,
                        MatSlideToggleModule,
                        VendorLibComponent,
                        FlexLayoutModule
                    ]
                },] }
    ];
    return VendorLibModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: vendor-lib.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { VendorLibService, VendorLibComponent, VendorLibModule };

//# sourceMappingURL=vendor-lib.js.map